<template>
  <div class="chat-widget__message-draft-progress" v-if="message.progress" >
    <Avatar :icon="assistantIcon" shape="circle" />
    <ProgressBar :value="message.progress" class="chat-widget__message-draft-progress-bar"></ProgressBar>
    <div v-if="message.waiting_message" class="chat-widget__message-draft-progress-message">{{ message.waiting_message }}</div>
  </div>
  <Skeleton height="8rem"></Skeleton>
</template>

<script setup>
import Skeleton from 'primevue/skeleton';
import ProgressBar from "primevue/progressbar";
import Avatar from "primevue/avatar";

const assistantIcon = 'pi pi-sparkles';

const props = defineProps({
  message: {
    type: Object,
    required: true
  }
});
</script>